export default {
      id: "svg-icon-pagination-next-usage",
      viewBox: "0 0 11.916 23.771",
      url: __webpack_public_path__ + "static/images/svg-icons.svg#svg-icon-pagination-next",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-svg/pagination-next.svg
// module id = UwsT
// module chunks = 4